import { useEffect, useState } from 'react';
import { useDataProvider, useNotify } from 'react-admin';
import { getFieldByTitle } from '../../../helpers/sortByTitle';
import { selectedFilterItems } from '../../../helpers/filter';
export interface Payment {
  groupId: string;
  totalCost: number;
  orderType?: string;
  // paymentWay: string;
  checkoutId: string;
  paypalId?: string;
  createdAt: string;
  purchaseDate?: string;
  paymentStatus: 'ACCEPTED' | 'REFUNDED';
}

export const useUserPayments = (userId) => {
  const [state, setState] = useState({
    orders: Array<Payment>(),
    total: 0,
    page: 1,
    perPage: 10,
    field: 'total',
    totalCost: 'asc',
    createdAt: 'asc',
    loading: false,
    refundItem: null,
  });
  const [bankedDialog, setBankedDialog] = useState({
    isOpen: false,
    activePayment: undefined,
  });
  const [filter, setFilter] = useState({
    searchField: '',
    status: [
      { id: 'REFUNDED', title: 'REFUNDED', isActive: true },
      { id: 'ACCEPTED', title: 'ACCEPTED', isActive: true },
    ],
    selectedStatuts: Array<string>(),
  });
  const [searchState, setSearchState] = useState({
    groupId: '',
  });
  const [dropdown, setDropdown] = useState({
    groupid: false,
    status: false,
  });

  const dataProvider = useDataProvider();
  const notify = useNotify();

  const closeBankedDialog = () =>
    setBankedDialog((state) => ({ ...state, isOpen: false }));

  useEffect(() => {
    getPayments(1, 10, 'total', 'asc', 'asc', '', '', Array<string>());
  }, []);

  const getPayments = async (
    page: number,
    perPage: number,
    field: string,
    totalCost: string,
    createdAt: string,
    searchString: string,
    searchField: string,
    selectedStatuts: Array<string>
  ) => {
    const orders = await dataProvider.getUserPayments({
      id: userId,
      pagination: { page: page, perPage: perPage },
      sort: { field: field, createdAt: createdAt, totalCost: totalCost },
      filter: {
        selectedStatuts,
        searchString: searchString,
        searchField: searchField,
      },
    });
    if (orders.data) {
      setState({
        ...state,
        orders: orders.data.orders,
        total: orders.data.allCount,
        page: page,
        perPage: perPage,
        field: field,
        createdAt: createdAt,
      });
    }
  };

  const applySearch = (field: string) => {
    setFilter({ ...filter, searchField: field });
    getPayments(
      1,
      10,
      '_id',
      'asc',
      'asc',
      searchState[field],
      field,
      filter.selectedStatuts
    );
  };

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ): void => {
    getPayments(
      newPage + 1,
      state.perPage,
      state.field,
      state.totalCost,
      state.createdAt,
      searchState[filter.searchField],
      filter.searchField,
      filter.selectedStatuts
    );
  };

  const handleLastPage = () => {
    const page = Math.ceil(state.total / state.perPage);
    getPayments(
      page,
      state.perPage,
      state.field,
      state.totalCost,
      state.createdAt,
      searchState[filter.searchField],
      filter.searchField,
      filter.selectedStatuts
    );
  };

  const handleFirstPage = () => {
    getPayments(
      1,
      state.perPage,
      state.field,
      state.totalCost,
      state.createdAt,
      searchState[filter.searchField],
      filter.searchField,
      filter.selectedStatuts
    );
  };

  const applyStatusFilter = () => {
    getPayments(
      1,
      state.perPage,
      state.field,
      state.totalCost,
      state.createdAt,
      searchState[filter.searchField],
      filter.searchField,
      filter.selectedStatuts
    );
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const perPage = parseInt(event.target.value, 10);
    getPayments(
      1,
      perPage,
      state.field,
      state.totalCost,
      state.createdAt,
      searchState[filter.searchField],
      filter.searchField,
      filter.selectedStatuts
    );
  };

  const handleSort = (direction: string, title: string) => {
    const field = getFieldByTitle(title);
    getPayments(
      state.page,
      state.perPage,
      field,
      direction,
      direction,
      searchState[filter.searchField],
      filter.searchField,
      filter.selectedStatuts
    );
  };

  const refundPayment = (item) => {
    switch (item.paymentWay) {
      case 'Checkout': {
        return async () => {
          try {
            setState((prev) => {
              return { ...prev, loading: true, refundItem: item.groupId };
            });
            const res = await dataProvider.refundCheckoutPayment({
              reference: item.groupId,
              checkoutId: item.checkoutId,
            });
            if (res.data) {
              notify('Order has been refunded', 'info');
              setState((prev) => {
                return { ...prev, loading: false, refundItem: null };
              });
              document.location.reload();
            }
          } catch (err) {
            setState((prev) => {
              return { ...prev, loading: false, refundItem: null };
            });
            notify(err.data.error, 'error');
          }
        };
      }
      case 'PayPal': {
        return async () => {
          try {
            setState((prev) => {
              return { ...prev, loading: true, refundItem: item.groupId };
            });
            const res = await dataProvider.refundPayPalPayment({
              reference: item.groupId,
              paypalId: item.paypalId,
            });
            if (res.data) {
              notify('Order has been refunded', 'info');
              setState((prev) => {
                return { ...prev, loading: false, refundItem: null };
              });
              document.location.reload();
            }
          } catch (err) {
            setState((prev) => {
              return { ...prev, loading: false, refundItem: null };
            });
            notify(err.data.error, 'error');
          }
        };
      }
      case 'OldCheckout': {
        return async () => {
          try {
            setState((prev) => {
              return { ...prev, loading: true, refundItem: item.groupId };
            });
            const res = await dataProvider.refundOldCheckoutPayment({
              reference: item.groupId,
              checkoutId: item.checkoutId,
            });
            if (res.data) {
              setState((prev) => {
                return { ...prev, loading: false, refundItem: null };
              });
              notify('Order has been refunded', 'info');
              document.location.reload();
            }
          } catch (err) {
            setState((prev) => {
              return { ...prev, loading: false, refundItem: null };
            });
            notify(err.data.error, 'error');
          }
        };
      }
      default: {
        return async () => {
          try {
            setState((prev) => {
              return { ...prev, loading: true, refundItem: item.groupId };
            });
            const res = await dataProvider.refundCheckoutPayment({
              reference: item.groupId,
              checkoutId: item.checkoutId,
            });
            if (res.data) {
              setState((prev) => {
                return { ...prev, loading: false, refundItem: null };
              });
              notify('Order has been refunded', 'info');
              document.location.reload();
            }
          } catch (err) {
            setState((prev) => {
              return { ...prev, loading: false, refundItem: null };
            });
            notify(err.data.error, 'error');
          }
        };
      }
    }
    // if (item.paymentWay === 'Checkout') {
    //   return async () => {
    //     try {
    //       const res = await dataProvider.refundCheckoutPayment({
    //         reference: item.groupId,
    //         checkoutId: item.checkoutId,
    //       });
    //       if (res.data) {
    //         notify('Order has been refunded', 'info');
    //         document.location.reload();
    //       }
    //     } catch (err) {
    //       notify(err.data.error, 'error');
    //     }
    //   };
    // }
    // return async () => {
    //   setBankedDialog((state) => ({
    //     ...state,
    //     isOpen: true,
    //     activePayment: item,
    //   }));
    // };
  };

  const sendReceipt = (item) => {
    return async () => {
      try {
        setState((prev) => {
          return { ...prev, loading: true };
        });
        let res;
        if (item.orderType === 'SUBSCRIPTION') {
          res = await dataProvider.sendSubscriptionReceiptEmail({
            reference: item.groupId,
            checkoutId: item.checkoutId,
            userId: userId,
          });
        } else {
          res = await dataProvider.sendReceiptEmail({
            reference: item.groupId,
            checkoutId: item.checkoutId,
            userId: userId,
          });
        }

        if (res.data) {
          setState((prev) => {
            return { ...prev, loading: false };
          });
          notify('Receipt sent', 'info');
        }
      } catch (err) {
        setState((prev) => {
          return { ...prev, loading: false };
        });
        notify(err.data.error, 'error');
      }
    };
  };

  const handleSelectStatus = (id: string, checked: boolean) => {
    const statuts = selectedFilterItems(id, checked, filter.selectedStatuts);
    setFilter({ ...filter, selectedStatuts: statuts });
  };

  const clearSelectedStatus = () => {
    setFilter({ ...filter, selectedStatuts: Array<string>() });
  };

  const selectedAllStatuts = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    let statuts = filter.status;
    if (checked) {
      const selectedStatuts = statuts.reduce((acc, item) => {
        acc.push(item.id);
        return acc;
      }, Array<string>());
      setFilter({ ...filter, selectedStatuts });
    } else {
      setFilter({ ...filter, selectedStatuts: Array<string>() });
    }
  };

  const filterDropdown = (title: string) => {
    const titleArray = title.toLowerCase().split(' ');
    setDropdown({ ...dropdown, [titleArray[0]]: !dropdown[titleArray[0]] });
  };
  const closeFilter = (e: any) => {
    setDropdown((state) => ({ ...state, groupid: false }));
  };

  const search = (value: string, field: string) => {
    setSearchState({ ...searchState, [field]: value });
  };

  const clearSearch = (clear: string) => {
    setSearchState({ ...searchState, [clear]: '' });
  };

  return {
    state,
    bankedDialog,
    setBankedDialog,
    handleChangeRowsPerPage,
    handleFirstPage,
    handleLastPage,
    handleChangePage,
    handleSort,
    refundPayment,
    applySearch,
    filterDropdown,
    closeFilter,
    dropdown,
    search,
    searchState,
    clearSearch,
    closeBankedDialog,
    filter,
    handleSelectStatus,
    clearSelectedStatus,
    selectedAllStatuts,
    applyStatusFilter,
    sendReceipt,
  };
};
